  @if (isAWS) {
          <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-150 fs-16">
            <mat-icon svgIcon="report_problem" class="icon-md-2 h-50 w-50 not-supported"></mat-icon>
            <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_SUPPORTED_FOR_AWS' | transloco}}</div>
          </div>
        } @else if ((featuresMap[FeatureKeys.DATABASE_SNAPSHOT_NONPII]
        || featuresMap[FeatureKeys.DATABASE_SNAPSHOT_PII]
        || featuresMap[FeatureKeys.DATABASE_SNAPSHOT_LIVE]
        || featuresMap[FeatureKeys.DATABASE_ARCHIVE_LIVE])) {
<div class="flex items-center justify-between">
  <div class="flex items-center">
    <mat-icon svgIcon="work_outline" class="mr-8"></mat-icon>
    <div class="mat-subtitle-2 mb-0 fs-24 fw-600">{{'TENANT_DETAILS.DATABASE_BACKUP' | transloco}}
      <span>({{searchTerm?.length > 0 && searchedResult ? searchedResult.length || 0 : (backupResults?.length || 0)}})</span>
    </div>
    <div class="ml-16 search-jobs">
      <app-search-filter class="mt-20 ml-20" placeholder="SEARCH.SEARCH" [ngClass]="{'disabled': !envDBResponse || dbLoading}" (changed)="search($event)"></app-search-filter>
    </div>
    <span class="vertical-dash ml-12"></span>
    <button [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || !(envDBResponse) || dbLoading) : !(envDBResponse) || dbLoading}" class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-12 filter"  (click)="filterColumns()">
      <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
      <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
    </button>
    </div>
      @if (dbdata?.length > 0) {
    <div class="flex flex-row gap-3 create-jobs">
        <button type="submit" class="flex accent h-32 mt-16 mr-8 create-btn" (click)="instance.status !== DeployStatus.TERMINATED && !dbInprogess && INSTANCE_AVAILABLE_STATUS.includes(instance?.status) ? createNewBackup() : ''" [ngClass]="{'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || !INSTANCE_AVAILABLE_STATUS.includes(instance?.status) || dbInprogess) : !INSTANCE_AVAILABLE_STATUS.includes(instance?.status) || dbInprogess}">
          <mat-icon svgIcon="add" class="mr-6 icon-sm"></mat-icon>{{'BUTTONS.CREATE' | transloco}}
        </button>
        <div class="flex items-center border-left mr-4"></div>

    <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer" (click)="refreshClick()">
        <mat-icon svgIcon="refresh" class="icons transition-transform duration-700" [ngClass]="{ 'animate-spin': isRefreshing }"></mat-icon>
    </div>
    <app-environment-paginator [length]="searchedResult?.length" [pageIndex]="pageIndex" [pageSize]="paginationSize" (page)="onPageChange($event)"></app-environment-paginator>
    </div>
  }
  </div>
   <div *ngIf="selectedDBType?.length > 0 || selectedDBName?.length > 0 || selectedStatus?.length > 0" class="flex flex-row flex-wrap items-center mt-4 ml-8">
          @if (selectedStatus?.length > 0) {
            <span class="pr-8 fs-16">{{ 'TOOLBAR.STATUS' | transloco }}</span>
          }
         <div class="mr-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedStatus?.length > 0">
               <span *ngFor="let status of selectedStatus" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
                  {{getStatusLabel(status) | titlecase}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelStatusFilter(status)"></mat-icon>
               </span>
         </div>
          @if (selectedDBType?.length > 0) {
            <span class="pr-8 fs-16">{{ 'TOOLBAR.BACKUP_TYPE' | transloco }}</span>
          }
         <div class="mr-4 filtered-items flex flex-wrap items-center fs-16 fw-500" *ngIf="selectedDBType?.length > 0">
               <span *ngFor="let dbType of selectedDBType" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
                  {{getDBTypeLabel(dbType) | titlecase}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelDBTypeFilter(dbType)"></mat-icon>
               </span>
         </div>
         @if (selectedDBName?.length > 0) {
            <span class="pr-8 fs-16">{{ 'TOOLBAR.LTR_TYPE' | transloco }}</span>
         }
         <div class="mr-4 filtered-items flex flex-wrap items-center fs-16 fw-500" *ngIf="selectedDBName?.length > 0">
               <span *ngFor="let dbName of selectedDBName" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
                  {{getDBNameLabel(dbName) | titlecase}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelDBNameFilter(dbName)"></mat-icon>
               </span>
         </div>


         <div class="flex flex-row items-center">
            <span *ngIf="selectedStatus?.length > 0 || selectedDBType?.length > 0 || selectedDBName?.length > 0" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetJobFilter()">
               {{ 'BUTTONS.CLEAR_ALL' | transloco }}
            </span>
         </div>
      </div>
    <mat-divider class="neutral-2 mt-12 mb-12 ml-4 mr-4"></mat-divider>
    <div *ngIf="envDBResponse && !showLoader" class="flex flex-col border-radius route-table mb-16 mt-8 envt-db">
    <app-environment-table class="runbook-table" [ngClass]="{'disabled': showLoader}" (searchedResults)="searchedItems($event)" [displayColumns]="displayColumns" [showSkeletonLoader]="dbLoading" [initialDataSource]="backupResults" [dataLoading]="dbLoading" [searchTerm]="searchTerm" [dataSourceLength]="true" [initialCreate]="dbdata?.length === 0" (runbookData)="getDatabases()" (sorted)="resetPaginator()" (pageModify)="onTablePageChanged($event)" [instanceName]="instance?.name" (pageChanged)="onPageChange($event)" pageName="environmentDatabases"></app-environment-table>
  </div>
  <div *ngIf="!envDBResponse && !apiNotFound && !showLoader " class="flex flex-col" >
  <div class="flex flex-col empty-panel ml-10 mr-16 mt-16">
    <div class="empty-data flex flex-col items-center mt-32 ">
      <img class="w-106" alt="jobs not found" src="/assets/images/service_not_found.png">
      <div class="flex mt-6 ">{{'INSTANCE_DETAILS.DATABASE_BACKUP.NO_DATA' | transloco }}</div>
    </div>
     <div class="flex justify-center mt-24">
      <button  type="button" class="flex accent justify-center items-center mat-subtitle-2 create-btn" mat-button
        (click)="instance.status !== DeployStatus.TERMINATED && !dbInprogess && INSTANCE_AVAILABLE_STATUS.includes(instance?.status) ? createNewBackup() : ''" [ngClass]="{'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || !INSTANCE_AVAILABLE_STATUS.includes(instance?.status) || dbInprogess) : !INSTANCE_AVAILABLE_STATUS.includes(instance?.status) || dbInprogess}">
        <mat-icon svgIcon="add" class="icon-md-2"></mat-icon>
        {{'BUTTONS.CREATE' | transloco }}
      </button>
    </div>
  </div>
</div>
@if (showLoader) {
<div class="loader-section">
  <div class="runbook-group loader-header flex flex-col p-16">
    <div class="flex flex-row">
      @for (tableColumn of displayColumns; track tableColumn?.key) {
        <div class="loader-style">
          <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>

  @for (item of [1, 2, 3]; track $index) {
    <div class="w-100-percent">
    <div class="runbook-group flex flex-col p-16">
      <div class="flex flex-row">
        @for (tableColumn of displayColumns; track tableColumn?.key) {
          <div class="loader-style">
            <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
    </div>
  }
</div>
}
}
